import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'shared-search-input',
  templateUrl: './search-input.component.html'
})
export class SearchInputComponent implements OnInit {

  @Input('placeholder')
  public placeholder: string = '';

  @Output('onEnter') 
  public onEnter: EventEmitter<string> = new EventEmitter();

  @Output('onDebounce')
  public onDebounce: EventEmitter<string> = new EventEmitter();

  public debouncer: Subject<string> = new Subject();

  @Input('value')
  public search: string = '';

  ngOnInit(): void {
    this.debouncer
      .pipe(debounceTime(300))
      .subscribe( value => this.onDebounce.emit(value));
  }

  /**
   * Emit the search value through the debouncer.
   */
  public onKeyPress() {
    this.debouncer.next(this.search);
  }

  /**
   * Clear textbox.
   */
  public onClearField() {
    this.search = '';
    this.onSearch();
  }

  /**
   * Emit a event when an element is selected.
   */
  public onSearch() {
    this.onEnter.emit(this.search);
  }
}